import React from 'react';
import { wrapReactionHook } from "../../hooks";
export var Section = wrapReactionHook(function (props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", null, "Section", children);
});